import React from 'react';
import './FormCustomerInfo.scss';
import { Icon } from 'antd';
import { DeliveryCode } from 'Store/Order/enums';
import InputField from 'Components/Shared/InputField/InputField';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import FormNewsLetter from 'Components/FormNewsLetter/FormNewsLetter';
import InputCountry from 'Components/InputCountry/InputCountry';

interface IProps {
  isLoggedIn: boolean;
  isShowingLoginHint: boolean;
  deliveryCode?: string;
  currentInput: Julius.Website.CustomerInfoViewModel;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onCountryChange: (value: string) => void;
  onEmailsAllowedChange: (isChecked: boolean) => void;
  onEmailBlur: (e: React.FormEvent<HTMLInputElement>) => void;
  setFormRef: (node: HTMLFormElement) => void;
}

const FormCustomerInfo: React.SFC<IProps> = ({
  isLoggedIn,
  isShowingLoginHint,
  deliveryCode,
  currentInput,
  onChange,
  onCountryChange,
  onEmailsAllowedChange,
  onEmailBlur,
  setFormRef,
}) => {

  const isAllFieldsNeeded = !(
    deliveryCode === DeliveryCode.E_TICKET || 
    deliveryCode === DeliveryCode.TEXT_MESSAGE || 
    deliveryCode === DeliveryCode.PICK_UP);
  
  return (
    <div className='form-customer-info'>
      <FormattedText 
        style='title' 
        displayName='Dina uppgifter'
        formattedName='order.customer.header'
      />
      <FormattedText 
        style='sub-title' 
        displayName='Fyll i dina uppgifter så att vi enkelt kan komma i kontakt med dig vid behov.'
        formattedName='order.customer.text'
      />
      { isLoggedIn &&
        <FormattedText 
          style='sub-title' 
          displayName='Alla uppgifter som ändras kommer att sparas på ditt konto.'
          formattedName='order.customer.save'
        />
      }
      
      <form ref={ setFormRef }>
        <InputField 
          name='email'
          type='email'
          value={ currentInput.email }
          label={ {
            displayName: 'E-post',
            formattedName: 'global.email',
          } }
          required={ true }
          onChange={ onChange }
          onBlur={ onEmailBlur }
          disabled={ isLoggedIn }
        >
          { isShowingLoginHint &&
            <div className='login-hint'>
              <Icon type="check-circle" />
              <FormattedText
                displayName='Vi känner igen din e-postadress! Logga in så hämtar vi dina uppgifter.'
                formattedName='order.customer.loginhint'
              />
            </div>
          }
        </InputField>
        <InputField 
          name='phone'
          type='text'
          value={ currentInput.phone }
          label={ {
            displayName: 'Mobilnummer',
            formattedName: 'global.phone',
          } }
          required={ true }
          onChange={ onChange }
        />
        <InputField 
          name='firstName'
          type='text'
          value={ currentInput.firstName }
          label={ {
            displayName: 'Förnamn',
            formattedName: 'global.firstname',
          } }
          required={ true }
          onChange={ onChange }
        />
        <InputField 
          name='lastName'
          type='text'
          value={ currentInput.lastName }
          label={ {
            displayName: 'Efternamn',
            formattedName: 'global.lastname',
          } }
          required={ true }
          onChange={ onChange }
        />

        { isAllFieldsNeeded &&
          <>
            <InputField 
              name='street'
              type='text'
              value={ currentInput.street }
              label={ {
                displayName: 'Gata',
                formattedName: 'global.street',
              } }
              required={ true }
              onChange={ onChange }
            />
            <InputField 
              name='zipcode'
              type='text'
              value={ currentInput.zipcode }
              label={ {
                displayName: 'Postnummber',
                formattedName: 'global.zipcode',
              } }
              required={ true }
              onChange={ onChange }
            />
            <InputField 
              name='city'
              type='text'
              value={ currentInput.city }
              label={ {
                displayName: 'Ort',
                formattedName: 'global.city',
              } }
              required={ true }
              onChange={ onChange }
            />
            <InputCountry 
              { ... { 
                initialCountryKey: currentInput.country, 
                onChange: onCountryChange,
              } } 
            />
          </>
        }
      </form>
      <FormNewsLetter onChange={ onEmailsAllowedChange } isChecked={ currentInput.isEmailsAllowed } />
    </div>
  );
}

export default FormCustomerInfo;


// WEBPACK FOOTER //
// ./src/components/FormCustomerInfo/FormCustomerInfo.tsx